import { CONVERSIONS, ENGAGEMENT, REACH, TRAFFIC, VIDEO_VIEWS } from '../../../constants/campaigns'

export const optimizeGoals = {
  [TRAFFIC]: 'CLICK',
  [CONVERSIONS]: 'CONVERT',
  [REACH]: 'REACH',
  [VIDEO_VIEWS]: 'ENGAGED_VIEW',
  [ENGAGEMENT]: 'FOLLOWERS'
}
